import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { NZ_MODAL_DATA, NzModalFooterDirective, NzModalModule, NzModalRef } from 'ng-zorro-antd/modal';
import { switchMap, takeUntil } from 'rxjs/operators';
import { BookingService, VisitService } from '@beautyapp/core';
import { catchError, Subject, throwError } from 'rxjs';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { AppointmentFacade } from '../../booking-modal/appointment-facade.service';
import { VisitAddFacade } from '@beautyapp/shared';

import { NzSpaceComponent, NzSpaceItemDirective, NzSpaceModule } from 'ng-zorro-antd/space';
import { NzButtonComponent, NzButtonModule } from 'ng-zorro-antd/button';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { TextareaComponent } from '../../../../../form/src/lib/textarea/textarea.component';

@Component({
  selector: 'beautyapp-visit-disable-reason',
  templateUrl: './visit-disable-reason.component.html',
  styleUrls: ['./visit-disable-reason.component.scss'],
  imports: [
    ReactiveFormsModule,
    TextareaComponent,
    NzModalModule,
    NzSpaceModule,
    NzButtonModule,
    NzAlertModule
]
})
export class VisitDisableReasonComponent implements OnDestroy {
  modal = inject(NzModalRef);
  private visitAddFacade = inject(VisitAddFacade);
  private visitService = inject(VisitService);

  readonly data = inject(NZ_MODAL_DATA);

  get visitId() {
    return this.data.visitId;
  }

  get paymentsCount(): number {
    return this.data.paymentsCount || 0;
  }

  get totalPaid(): number {
    return this.data.totalPaid || 0;
  }

  isLoading: any = false;

  form: UntypedFormGroup = new UntypedFormGroup({
    disableReason: new UntypedFormControl(null)
  });

  sub$ = new Subject();

  deleteBooking() {
    this.isLoading = true;
    this.visitAddFacade.loading.set(true);
    this.visitService.disableVisit(this.visitId, this.form.value)
      .pipe(
        takeUntil(this.sub$),
        catchError((error) => {
          this.visitAddFacade.loading.set(false);
          return throwError(() => error);
        })
      )
      .subscribe((res) => {
        this.modal.triggerOk();
        this.visitAddFacade.loading.set(false);
        this.isLoading = false;
      });
  }

  ngOnDestroy(): void {
    this.sub$.next(null);
    this.sub$.complete();
  }
}
